document.addEventListener('DOMContentLoaded', function () {
  if (window.__mtInit) return;
  window.__mtInit = true;
  initReveal();
  initContadores();
  initGaleriaProducto();
  initCantidadProducto();
  initVariantesProducto();
  initBarraFija();
  initLegalFormulario();
  initPrecioUnidad();
  initComparadores();
  initPausarCintas();
});

// Las cintas animadas (reseñas, usos) solo se mueven mientras están en pantalla: ahorra trabajo al celular.
function initPausarCintas() {
  var cintas = document.querySelectorAll('.mt-resenas__track, .mt-multi__track');
  if (!cintas.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.target.classList.toggle('mt-pausado', !e.isIntersecting); });
  });
  cintas.forEach(function (c) { c.classList.add('mt-pausado'); io.observe(c); });
}

function initComparadores() {
  document.querySelectorAll('[data-mt-comparador]').forEach(function (comp) {
    var imgs = comp.querySelector('.mt-comparador__imgs');
    var handle = comp.querySelector('[data-mt-comp-handle]');
    if (!imgs || !handle) return;
    var arrastrando = false;

    function fijarPos(clientX) {
      var rect = imgs.getBoundingClientRect();
      var pct = ((clientX - rect.left) / rect.width) * 100;
      pct = Math.max(0, Math.min(100, pct));
      comp.style.setProperty('--mt-comp-pos', pct + '%');
    }

    function inicio(e) {
      arrastrando = true;
      fijarPos((e.touches ? e.touches[0].clientX : e.clientX));
    }
    function mover(e) {
      if (!arrastrando) return;
      fijarPos((e.touches ? e.touches[0].clientX : e.clientX));
    }
    function fin() { arrastrando = false; }

    handle.addEventListener('pointerdown', inicio);
    imgs.addEventListener('pointerdown', inicio);
    window.addEventListener('pointermove', mover);
    window.addEventListener('pointerup', fin);
    handle.addEventListener('touchstart', inicio, { passive: true });
    imgs.addEventListener('touchstart', inicio, { passive: true });
    window.addEventListener('touchmove', mover, { passive: true });
    window.addEventListener('touchend', fin);
  });
}

function initGaleriaProducto() {
  var miniaturas = document.querySelectorAll('.mt-producto__miniatura');
  var principal = document.getElementById('mt-img-principal');
  if (!miniaturas.length || !principal) return;
  miniaturas.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var video = document.getElementById('mt-video-principal');
      var srcVideo = btn.getAttribute('data-mt-video');
      if (video) {
        if (srcVideo) { video.src = srcVideo; video.hidden = false; principal.style.visibility = 'hidden'; var pr = video.play(); if (pr && pr.catch) pr.catch(function () {}); }
        else { video.pause(); video.hidden = true; principal.style.visibility = ''; }
      }
      principal.removeAttribute('srcset');
      principal.src = btn.getAttribute('data-mt-full');
      miniaturas.forEach(function (b) { b.classList.remove('mt-activa'); });
      btn.classList.add('mt-activa');
      var idx = Array.prototype.indexOf.call(miniaturas, btn);
      var contador = document.getElementById('mt-galeria-contador');
      if (contador) contador.textContent = (idx + 1) + ' / ' + miniaturas.length;
      // Mantiene la miniatura activa visible en la fila, sin mover la página.
      var fila = btn.parentNode;
      var izq = btn.getBoundingClientRect().left - fila.getBoundingClientRect().left + fila.scrollLeft, der = izq + btn.offsetWidth;
      if (izq < fila.scrollLeft || der > fila.scrollLeft + fila.clientWidth) {
        fila.scrollTo({ left: Math.max(0, izq - (fila.clientWidth - btn.offsetWidth) / 2), behavior: 'smooth' });
      }
    });
  });

  // Slides: flechas y deslizar con el dedo sobre la imagen grande.
  function ir(paso) {
    var actual = Array.prototype.findIndex.call(miniaturas, function (b) { return b.classList.contains('mt-activa'); });
    var n = miniaturas.length;
    miniaturas[((actual < 0 ? 0 : actual) + paso + n) % n].click();
  }
  document.querySelectorAll('[data-mt-galeria]').forEach(function (f) {
    f.addEventListener('click', function () { ir(parseInt(f.getAttribute('data-mt-galeria'), 10)); });
  });
  var caja = principal.parentNode, x0 = null, y0 = null;
  caja.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
  caja.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
    x0 = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) ir(dx < 0 ? 1 : -1);
  }, { passive: true });
}

function initCantidadProducto() {
  var input = document.getElementById('mt-cantidad');
  if (!input) return;
  document.querySelectorAll('.mt-producto__cant-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var val = parseInt(input.value, 10) || 1;
      if (btn.getAttribute('data-mt-cant') === 'mas') val += 1;
      else val = Math.max(1, val - 1);
      input.value = val;
    });
  });
}

function initVariantesProducto() {
  var json = document.getElementById('mt-variantes-json');
  var form = document.getElementById('mt-form-producto');
  if (!json || !form) return;
  var variantes = JSON.parse(json.textContent);
  var grupos = form.querySelectorAll('.mt-producto__opcion-valores');
  var idInput = document.getElementById('mt-variant-id');
  var addBtn = document.getElementById('mt-add-boton');
  var addTexto = document.getElementById('mt-add-texto');
  var precioActual = document.getElementById('mt-precio-actual');
  var precioAntes = document.getElementById('mt-precio-antes');

  // Moneda activa del visitante (MXN en México, USD en EE. UU., etc.), igual que money_with_currency en Liquid.
  var moneda = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'MXN';
  var simbolo = '$';
  try {
    var parteSimbolo = new Intl.NumberFormat('es-MX', { style: 'currency', currency: moneda, currencyDisplay: 'narrowSymbol' })
      .formatToParts(1).find(function (p) { return p.type === 'currency'; });
    if (parteSimbolo) simbolo = parteSimbolo.value;
  } catch (e) {}

  function formatearDinero(centavos, conCodigo) {
    var texto = simbolo + ' ' + (centavos / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return conCodigo ? texto + ' ' + moneda : texto;
  }

  function seleccionActual() {
    var sel = [];
    grupos.forEach(function (g) {
      var activo = g.querySelector('.mt-activa');
      sel.push(activo ? activo.getAttribute('data-mt-valor') : null);
    });
    return sel;
  }

  function actualizar() {
    var sel = seleccionActual();
    var variante = variantes.find(function (v) {
      var opciones = [v.option1, v.option2, v.option3].filter(function (o) { return o !== null && o !== undefined; });
      return sel.every(function (val, i) { return val === opciones[i]; });
    });
    if (!variante) return;
    idInput.value = variante.id;
    var btnPrecio = document.getElementById('mt-add-precio');
    var ahorroEl = document.getElementById('mt-ahorro');
    function cortoMx(c) { var n = c / 100; return simbolo + ' ' + n.toLocaleString('es-MX', { maximumFractionDigits: n % 1 ? 2 : 0 }) + ' ' + moneda; }
    if (btnPrecio) btnPrecio.textContent = '\u00a0· ' + cortoMx(variante.price);
    if (ahorroEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        var dif = (variante.compare_at_price - variante.price) / 100;
        var difTexto = simbolo + ' ' + dif.toLocaleString('es-MX', { maximumFractionDigits: dif % 1 ? 2 : 0, minimumFractionDigits: dif % 1 ? 2 : 0 });
        ahorroEl.textContent = (ahorroEl.getAttribute('data-mt-ahorro-texto') || 'Ahorras') + ' ' + difTexto + ' (' + Math.round((variante.compare_at_price - variante.price) * 100 / variante.compare_at_price) + '%)';
        ahorroEl.removeAttribute('hidden');
      } else { ahorroEl.setAttribute('hidden', ''); }
    }
    if (variante.featured_media && variante.featured_media.id) {
      var miniVariante = document.querySelector('.mt-producto__miniatura[data-mt-media-id="' + variante.featured_media.id + '"]');
      if (miniVariante && !miniVariante.classList.contains('mt-activa')) miniVariante.click();
    }
    if (precioActual) precioActual.textContent = formatearDinero(variante.price, true);
    if (precioAntes) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioAntes.textContent = formatearDinero(variante.compare_at_price);
        precioAntes.removeAttribute('hidden');
      } else {
        precioAntes.setAttribute('hidden', '');
      }
    }
    if (variante.available) {
      addBtn.removeAttribute('disabled');
      addTexto.textContent = addBtn.getAttribute('data-mt-texto-disponible') || addTexto.textContent;
    } else {
      addBtn.setAttribute('disabled', 'disabled');
      addTexto.textContent = addBtn.getAttribute('data-mt-texto-agotado') || 'Agotado';
    }
  }

  grupos.forEach(function (grupo) {
    grupo.querySelectorAll('.mt-producto__pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        grupo.querySelectorAll('.mt-producto__pill').forEach(function (p) { p.classList.remove('mt-activa'); });
        pill.classList.add('mt-activa');
        actualizar();
      });
    });
  });
}

function initReveal() {
  var els = Array.prototype.slice.call(document.querySelectorAll('.mt-reveal'));
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  // Lo que ya está en la primera pantalla se queda visible desde el inicio (sin parpadeo ni hueco en blanco).
  var pendientes = els.filter(function (el) {
    if (el.getBoundingClientRect().top < window.innerHeight) return false;
    el.classList.add('mt-oculto');
    return true;
  });
  // 29/09: revisión por scroll (antes IntersectionObserver): en celular algunas piezas (p. ej. el modelo 3D)
  // se quedaban invisibles porque el observer no avisaba con content-visibility. Ahora se revisa la posición real.
  var programado = false;
  function revisar() {
    programado = false;
    var alto = window.innerHeight;
    pendientes = pendientes.filter(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < alto - 40 && r.bottom > 0) {
        var delay = Number(el.getAttribute('data-mt-delay') || 0);
        setTimeout(function () { el.classList.add('mt-visible'); }, delay);
        return false;
      }
      return true;
    });
    if (!pendientes.length) { window.removeEventListener('scroll', pedir); window.removeEventListener('resize', pedir); }
  }
  function pedir() { if (!programado) { programado = true; requestAnimationFrame(revisar); } }
  window.addEventListener('scroll', pedir, { passive: true });
  window.addEventListener('resize', pedir);
  pedir();
}

function initContadores() {
  var els = document.querySelectorAll('[data-mt-contador]');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var fin = parseFloat(el.getAttribute('data-mt-contador'));
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = fin * (1 - Math.pow(1 - progreso, 3));
        el.textContent = (fin % 1 === 0 ? Math.round(valor) : valor.toFixed(1)).toString().replace('.', ',');
        if (progreso < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
      observer.unobserve(el);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) {
    // Lo que ya está en la primera pantalla se queda visible desde el inicio (sin parpadeo ni hueco en blanco).
    if (el.getBoundingClientRect().top < window.innerHeight) return;
    el.classList.add('mt-oculto');
    observer.observe(el);
  });
}

function initBarraFija() {
  var barra = document.getElementById('mt-sticky');
  var addBtn = document.getElementById('mt-add-boton');
  var form = document.getElementById('mt-form-producto');
  var btn = document.getElementById('mt-sticky-btn');
  var precio = document.getElementById('mt-precio-actual');
  var precioBarra = document.getElementById('mt-sticky-precio');
  if (!barra || !addBtn || !form || !btn) return;
  function sincronizar() {
    if (precio && precioBarra) precioBarra.textContent = precio.textContent;
    var antes = document.getElementById('mt-precio-antes');
    var bAntes = document.getElementById('mt-sticky-antes');
    var mAntes = document.getElementById('mt-movil-antes');
    var mPrecio = document.getElementById('mt-movil-precio');
    if (mPrecio && precio) mPrecio.textContent = precio.textContent;
    [bAntes, mAntes].forEach(function (el) {
      if (!el || !antes) return;
      el.textContent = antes.textContent;
      if (antes.hidden) el.setAttribute('hidden', ''); else el.removeAttribute('hidden');
    });
    btn.disabled = addBtn.disabled;
    var t = document.getElementById('mt-add-texto');
    if (t) btn.textContent = t.textContent;
  }
  if (precio && 'MutationObserver' in window) new MutationObserver(sincronizar).observe(precio, { childList: true, characterData: true, subtree: true });
  var antesEl = document.getElementById('mt-precio-antes');
  if (antesEl && 'MutationObserver' in window) new MutationObserver(sincronizar).observe(antesEl, { childList: true, characterData: true, subtree: true, attributes: true });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      barra.classList.toggle('mt-visible', !visible);
      barra.setAttribute('aria-hidden', visible ? 'true' : 'false');
      btn.tabIndex = visible ? -1 : 0;
      sincronizar();
    }).observe(addBtn);
  }
  btn.addEventListener('click', function () {
    if (btn.disabled) return;
    if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
  });
  sincronizar();
}

if (!window.__mtClickCard) {
window.__mtClickCard = true;
document.addEventListener('click', function (e) {
  var b = e.target.closest ? e.target.closest('.mt-card-add') : null;
  if (!b) return;
  e.preventDefault(); e.stopPropagation();
  var url = b.getAttribute('data-mt-elegir');
  if (url) { window.location.href = url; return; }
  var id = b.getAttribute('data-mt-add');
  if (!id || b.disabled) return;
  b.disabled = true; var t = b.textContent; b.textContent = '…';
  fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) })
    .then(function () { window.location.href = '/cart'; })
    .catch(function () { b.disabled = false; b.textContent = t; });
}, true);
}

function initPrecioUnidad() {
  var json = document.getElementById('mt-variantes-json');
  var form = document.getElementById('mt-form-producto');
  if (!json || !form) return;
  var variantes;
  try { variantes = JSON.parse(json.textContent); } catch (e) { return; }
  var en = (document.documentElement.lang || '').indexOf('en') === 0;
  var grupos = form.querySelectorAll('.mt-producto__opcion-valores');
  grupos.forEach(function (g, idx) {
    var pills = g.querySelectorAll('.mt-producto__pill');
    var esCantidad = pills.length > 0 && Array.prototype.every.call(pills, function (p) { return /^\d+\s/.test((p.getAttribute('data-mt-valor') || '').trim()); });
    if (!esCantidad) return;
    pills.forEach(function (p) {
      var valor = (p.getAttribute('data-mt-valor') || '').trim();
      var unidades = parseInt(valor, 10);
      if (!unidades || unidades < 2) return;
      var v = variantes.find(function (x) { return [x.option1, x.option2, x.option3][idx] === valor; });
      if (!v) return;
      var porUnidad = Math.round(v.price / 100 / unidades);
      var esSet = /set/i.test(valor);
      var etiqueta = esSet ? (en ? 'per set' : 'por set') : (en ? 'each' : 'c/u');
      if (p.querySelector('.mt-pill-unidad')) return;
      var s = document.createElement('small');
      s.className = 'mt-pill-unidad';
      var mon = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'MXN';
      s.textContent = (mon === 'EUR' ? '€' : '$') + porUnidad.toLocaleString('es-MX') + ' ' + mon + ' ' + etiqueta;
      p.appendChild(s);
      var suelto = v.compare_at_price && v.compare_at_price > v.price ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
      if (suelto > 0) {
        var sa = document.createElement('small');
        sa.className = 'mt-pill-ahorro';
        sa.textContent = (en ? 'Save ' : 'Ahorras ') + suelto + '%';
        p.appendChild(sa);
      }
    });
  });
}

// hCaptcha (de Shopify) enlaza a las políticas de hCaptcha; aquí añadimos las de la tienda junto a él.
function initLegalFormulario() {
  var en = (document.documentElement.lang || '').indexOf('en') === 0;
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function anadir() {
    document.querySelectorAll('form').forEach(function (f) {
      if (f.querySelector('.mt-legal-form')) return;
      var tipo = f.querySelector('input[name=form_type]');
      if (!tipo || (tipo.value !== 'contact' && tipo.value !== 'customer')) return;
      if (f.closest('.mt-popup')) return;
      var p = document.createElement('p');
      p.className = 'mt-legal-form';
      p.innerHTML = en
        ? 'By submitting you accept the <a href="' + raiz + 'policies/privacy-policy">Privacy Policy</a> and <a href="' + raiz + 'policies/terms-of-service">Terms of Service</a> of Flowipe.'
        : 'Al enviar aceptas la <a href="' + raiz + 'policies/privacy-policy">Política de privacidad</a> y los <a href="' + raiz + 'policies/terms-of-service">Términos del servicio</a> de Flowipe.';
      f.appendChild(p);
    });
  }
  anadir();
  setTimeout(anadir, 1500);
  setTimeout(anadir, 4000);
}

/* 04/10: en las tarjetas de producto se muestra el promedio (4.9) en lugar del total de reseñas */
(function () {
  var SEL = '.card-wrapper .jdgm-prev-badge, .mt-completa__card .jdgm-prev-badge, .product-grid .jdgm-prev-badge';
  var pendiente = false;
  function ajustar() {
    pendiente = false;
    document.querySelectorAll(SEL).forEach(function (b) {
      var t = b.querySelector('.jdgm-prev-badge__text');
      var r = parseFloat(b.getAttribute('data-average-rating'));
      if (!t || !r) return;
      var v = (Math.floor(r * 10) / 10).toFixed(1);
      if (t.textContent.trim() !== v) t.textContent = v;
    });
  }
  function agendar() { if (!pendiente) { pendiente = true; setTimeout(ajustar, 60); } }
  document.addEventListener('DOMContentLoaded', function () {
    agendar();
    new MutationObserver(agendar).observe(document.body, { childList: true, subtree: true, characterData: true });
  });
})();

/* Celular: la descripción larga de la ficha se pliega con "Ver más" */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    var d = document.querySelector('.mt-producto__descripcion-rica');
    if (!d || d.scrollHeight < 330) return;
    var en = (document.documentElement.lang || '').indexOf('en') === 0;
    d.classList.add('mt-plegable');
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'mt-vermas'; b.setAttribute('aria-expanded', 'false');
    b.textContent = en ? 'Read more' : 'Ver más';
    b.addEventListener('click', function () {
      var abierta = d.classList.toggle('mt-abierta');
      b.setAttribute('aria-expanded', abierta ? 'true' : 'false');
      b.textContent = abierta ? (en ? 'Show less' : 'Ver menos') : (en ? 'Read more' : 'Ver más');
    });
    d.parentNode.insertBefore(b, d.nextSibling);
  });
})();


/* 16/10: al agregar desde la ficha, un paquete de 2 o 3 unidades entra al carrito como "1 unidad" × cantidad (mismo color).
   Así el carrito nunca tiene líneas separadas del mismo producto y el cuadro de + y − cuenta unidades. El precio por volumen lo
   calculan los descuentos automáticos de Shopify. */
(function () {
  function iniciar() {
    var form = document.getElementById('mt-form-producto');
    var json = document.getElementById('mt-variantes-json');
    var idInput = document.getElementById('mt-variant-id');
    if (!form || !json || !idInput) return;
    /* Solo en pesos: en dólares y euros se conservan los paquetes con su precio exacto. */
    if ((form.getAttribute('data-mt-moneda') || 'MXN') !== 'MXN') return;
    var variantes;
    try { variantes = JSON.parse(json.textContent); } catch (e) { return; }
    var RX = /(\d+)\s*(unidades|unidad|cepillos|cepillo|units|unit|brushes|brush)/i;
    function unidades(t) { var m = RX.exec(t || ''); return m ? parseInt(m[1], 10) : null; }
    function baseDe(t) { return String(t || '').replace(RX, '').replace(/^[\s\/·\-]+|[\s\/·\-]+$/g, ''); }
    form.addEventListener('submit', function () {
      var id = String(idInput.value), sel = null;
      for (var i = 0; i < variantes.length; i++) { if (String(variantes[i].id) === id) { sel = variantes[i]; break; } }
      if (!sel) return;
      var u = unidades(sel.title);
      if (!u || u < 2) return;
      var b = baseDe(sel.title), uno = null;
      for (var k = 0; k < variantes.length; k++) {
        var v = variantes[k];
        if (unidades(v.title) === 1 && baseDe(v.title) === b && v.available) { uno = v; break; }
      }
      if (!uno) return;
      idInput.value = uno.id;
      var q = form.querySelector('input[name="quantity"]');
      if (q) q.value = String(u * (parseInt(q.value, 10) || 1));
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
